import Vue from 'vue';

import store from '@/store';
import router from '@/router';
import config from '@/config';

import App from './App.vue';

Vue.config.productionTip = false;

new Vue({
  store,
  router,
  config,
  render: (h) => h(App),
}).$mount('#app');
